"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Links_1 = require("../rac/Links");
var StyledRACLink = (0, styled_1.default)(Links_1.Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  font-weight: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  font-weight: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var mode = _a.mode, theme = _a.theme;
    return mode === 'DARK' ? theme.colors.blue300 : theme.colors.actionPrimary;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontWeights.medium;
}, function (_a) {
    var mode = _a.mode, theme = _a.theme;
    return mode === 'DARK'
        ? theme.colors.blue200
        : theme.colors.actionPrimaryHovered;
});
var LinkComponent = react_1.default.forwardRef(function (_a, ref) {
    var mode = _a.mode, props = __rest(_a, ["mode"]);
    return (react_1.default.createElement(StyledRACLink, __assign({ ref: ref, "data-theme": mode === null || mode === void 0 ? void 0 : mode.toLowerCase() }, props)));
});
LinkComponent.displayName = 'Link';
exports.Link = (0, styled_1.default)(LinkComponent)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map